// Cheap suffix gate for near-me routing; slug membership is confirmed against the
// BE catalog (isActiveSrpSlug) by the caller.
export const NEAR_ME_SLUG_SUFFIX = '-near-me';

export function isNearMeSlugCandidate(segment: string): boolean {
  return segment.length > NEAR_ME_SLUG_SUFFIX.length && segment.endsWith(NEAR_ME_SLUG_SUFFIX);
}
